import { Subject } from "rxjs";

const FileSaveSubject = new Subject();

export { FileSaveSubject };



// WEBPACK FOOTER //
// ./src/shared/FileSaveSubject.js